import { render, staticRenderFns } from "./organisation-form.vue?vue&type=template&id=78307ee1"
import script from "./organisation-form.vue?vue&type=script&lang=js"
export * from "./organisation-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports